import React from 'react'
import PropTypes from 'prop-types'
import { CSSTransition } from 'react-transition-group'
import './index.less'

class Popup extends React.Component {
  static propTypes = {
      children: () => {},
      closePopup: PropTypes.func,
      isShowPopup: PropTypes.bool,
      titleText: PropTypes.string,
      btnText: PropTypes.string
  };

  constructor (props) {
      super(props)
      this.state = {}
  }

  componentDidUpdate () {}

  UNSAFE_componentWillReceiveProps (nextProps) {
      if (nextProps.isShowPopup === this.props.isShowPopup) {
          return
      }
      if (nextProps.isShowPopup) {
          const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop
          document.body.style.top = -scrollTop + 'px'
          document.body.style.position = 'fixed'
      } else {
          const scrollTop = -parseInt(document.body.style.top)
          document.body.style.position = 'static'
          document.body.scrollTop = scrollTop
          document.documentElement.scrollTop = scrollTop
          document.body.style.top = ''
      }
  }

  render () {
      const { isShowPopup, children, closePopup } = this.props
      return (
          <div className="popup">
              <CSSTransition
                  in={isShowPopup}
                  timeout={500}
                  classNames="fades"
                  unmountOnExit
              >
                  {<div className="popup-mask" />}
              </CSSTransition>

              <CSSTransition
                  in={isShowPopup}
                  timeout={500}
                  classNames="up-down"
                  unmountOnExit
              >
                  <div className="popup-content">
                      <div className="popup-header">
                          <h3>{this.props.titleText}</h3>
                      </div>
                      <div className="popup-body">{children}</div>
                      <div className="popup-footer">
                          <button type="button" onClick={closePopup}>
                              {this.props.btnText}
                          </button>
                      </div>
                  </div>
              </CSSTransition>
          </div>
      )
  }
}

export default Popup
